import React from 'react';
import { List, Spin } from 'antd';  
import { LoadingOutlined } from '@ant-design/icons'; 
import WidgetCourseListItem from '../WidgetCourseListItem/WidgetCourseListItem';
import './styles.less';

const WidgetCourseList = ( { course, courseStartCallback, enabled, loading } ) => {
    return (
        <div className="widget-course-list">
            <List
                size="large" 
                bordered
                loading={ loading && { 
                    indicator: 
                        <Spin indicator={ <LoadingOutlined style={ { fontSize: 32 } } spin /> } /> 
                } }
                dataSource={ course.learningObjects }
                renderItem={ item => 
                    <WidgetCourseListItem
                        enabled={ enabled }
                        learningObject={ item }
                        courseStartCallback={ courseStartCallback }
                    /> 
                }
            />
        </div>
    );
};

export default WidgetCourseList;
